export function extractValues(obj) {
    const result = [];

    Object.values(obj).forEach(innerObj => {
        Object.values(innerObj).forEach(arr => {
            if (Array.isArray(arr)) {
                result.push(...arr);
            }
        });
    });

    return result;
}